import React from "react";
import {
  transform_languages,
  transform_skillLevel
} from "../Transformation/Transformations";

function LeaderProfileDetailsRegular({ currentLeader, t }) {
  return (
    <div className="flex flex-col gap-4 w-full mt-20 items-center xl:items-start">
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.age")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {currentLeader?.owner?.age}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.first_language")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {t(transform_languages(currentLeader?.owner?.first_language))}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.first_language_skill")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {t(
            transform_skillLevel(
              currentLeader?.owner?.first_language_skill_level
            )
          )}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.also_speak")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {t(currentLeader?.owner?.also_speak)}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.teaching_language")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {t(transform_languages(currentLeader?.teaching_language))}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.training_language_skill")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {t(
            transform_skillLevel(currentLeader?.teaching_language_skill_level)
          )}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.introduction")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {currentLeader?.introduction}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.interested_topic")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {currentLeader?.interested_topics}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("leader_profile.school")}
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {currentLeader?.owner?.school}
        </span>
      </div>
      <div>
        <span className="text-[20px] md:text-3xl font-medium">
          {t("user_home.city_country")}: 
        </span>
        <span className="text-lg md:text-2xl font-normal pl-2">
          {currentLeader?.owner?.city_country}
        </span>
      </div>
    </div>
  );
}

export default LeaderProfileDetailsRegular;
